import { React } from "aaa";
import { AppContainer } from "components/app/AppContainer";
import messagesDe from "i18n/de";
import messagesEn from "i18n/en";
import { observer, Provider } from "mobx-react";
import { addLocaleData, IntlProvider } from "react-intl";
// init global stores
import authStore from "stores/AuthStore";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { isMobile } from "util/helpers";
import * as moment from "moment";

var de = require("react-intl/locale-data/de");
var en = require("react-intl/locale-data/en");
addLocaleData([...en, ...de]);

const messages = {
    en: messagesEn,
    de: messagesDe
};

// Translate a11y
moment.updateLocale("de", {
    weekdays: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"]
});
moment.updateLocale("de", {
    weekdaysMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"]
});
moment.updateLocale("de", {
    months: ["Jänner", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
});

const stores = {
    authStore,
    externalInterfaceStore
};

@observer
class App extends React.Component<{}, {}> {
    parseQuery() {
        // Order is
        // - first authStore is rehydrated
        // - then externalInterfaceStore connected to query
        // - then start rendering (see below)
        if (authStore.isRehydrated) {
            externalInterfaceStore.subscribeToHistory();
        }
    }

    componentDidMount() {
        this.parseQuery();
    }

    componentDidUpdate() {
        this.parseQuery();
    }

    render() {
        const startupSequenceComplete =
            authStore.isRehydrated
            && externalInterfaceStore.queryParsed;

        return (
            <Provider {...stores}>
                <IntlProvider locale={authStore.locale} messages={messages[authStore.locale]}>
                    <>
                        {startupSequenceComplete && <AppContainer />}
                    </>
                </IntlProvider>
            </Provider>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx